export const boardHistoryTour = {
  key: "boardHistory",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-history-filters"]',
      content: t("Tour_BoardHistory_Filters"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-history-timeline"]',
      content: t("Tour_BoardHistory_Timeline"),
      placement: "top",
    },
  ],
};
